/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * May be null for 'fast' method
 * @export
 * @interface SlowAlignmentOptions
 */
export interface SlowAlignmentOptions {
    /**
     * Maps to ClustalW MAXDIV parameter: Percent identity for delay
     * @type {number}
     * @memberof SlowAlignmentOptions
     */
    identity?: number;
    /**
     * Maps to ClustalW GAPOPEN parameter: gap opening penalty 
     * @type {number}
     * @memberof SlowAlignmentOptions
     */
    gapCreationPenalty?: number;
    /**
     * Maps to ClustalW GAPEXT parameter: gap extension penalty 
     * @type {number}
     * @memberof SlowAlignmentOptions
     */
    gapExtensionPenalty?: number;
}

/**
 * Check if a given object implements the SlowAlignmentOptions interface.
 */
export function instanceOfSlowAlignmentOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SlowAlignmentOptionsFromJSON(json: any): SlowAlignmentOptions {
    return SlowAlignmentOptionsFromJSONTyped(json, false);
}

export function SlowAlignmentOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlowAlignmentOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'identity': !exists(json, 'identity') ? undefined : json['identity'],
        'gapCreationPenalty': !exists(json, 'gapCreationPenalty') ? undefined : json['gapCreationPenalty'],
        'gapExtensionPenalty': !exists(json, 'gapExtensionPenalty') ? undefined : json['gapExtensionPenalty'],
    };
}

export function SlowAlignmentOptionsToJSON(value?: SlowAlignmentOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'identity': value.identity,
        'gapCreationPenalty': value.gapCreationPenalty,
        'gapExtensionPenalty': value.gapExtensionPenalty,
    };
}

